var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{ref:"screen1",staticClass:"screen1"}),_c('div',{ref:"screen2",staticClass:"screen2"}),_c('div',{ref:"screen3",staticClass:"screen3"})])
}
var staticRenderFns = []

export { render, staticRenderFns }